import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// 1.46.0.0 : feuilles des themes, apres index.css (lib/theme.js pose les classes sur <html>).
import "@/styles/themes/commun.css";
import "@/styles/themes/lagon.css";
import "@/styles/themes/balise.css";
import "@/styles/themes/abysses.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
